export default [
  'EUR', 'CHF', 'USD', 'GBP'
]